export const ERROR_MESSAGES = {
  REQUEST_FAILED: 'Something went wrong. Please try again later',
};
